import './styles.scss';

const WithSidebarLayout = ({ Sidebar, children, mobileReversed = false }) => (
    <div className={`with-sidebar-layout ${mobileReversed ? 'mobile-reverse' : ''}`}>
        <div className="with-sidebar-layout__left">{Sidebar}</div>
        <div className="with-sidebar-layout__right">{children}</div>
    </div>
);

export default WithSidebarLayout;
